import { render } from "./BarChart.vue?vue&type=template&id=75d143a8"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
script.render = render

export default script